var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polyline, _polygon8, _polygon9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobKetherShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #35202f;\n      }\n\n      .cls-2 {\n        fill: #301d29;\n      }\n\n      .cls-3 {\n        fill: #261722;\n      }\n\n      .cls-4 {\n        fill: #3f2738;\n      }\n\n      .cls-5 {\n        fill: #5b4956;\n      }\n\n      .cls-6 {\n        fill: #b50cba;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "455.99 364 433.4 367.39 386.39 367.39 386.39 327.37 455.99 337.83 455.99 364"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "471.29 307.65 240.16 343.65 199.16 359.66 419.48 360.68 471.29 307.65"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "284.48 335.68 254.48 360.68 199.16 359.54 240.49 343.43 284.48 335.68"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "444.91 381.16 243.47 369.76 199.16 359.66 418.03 360.91 444.91 381.16"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "436.64 399.22 323.18 395.66 308.48 386.68 436.64 389.8 436.64 399.22"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "346.06 384.5 241.57 378.5 241.57 374.22 346.06 368.22 346.06 384.5"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "431.32 389.8 318.09 387.73 314.58 359.43 419.03 360.91 431.32 389.8"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "471.29 307.65 297.28 322.99 240.16 343.65 471.45 307.43"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "471.45 307.43 357.48 325.68 297.48 322.68 471.45 307.43"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "419.48 360.68 406.48 335.68 357.48 325.68 470.48 307.68 419.48 360.68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobKetherShip);
export default __webpack_public_path__ + "static/media/mob-kether-ship.5f47f14322ae1f0b915faa956451b3a2.svg";
export { ForwardRef as ReactComponent };